import axiosInstance from "../api/axiosInstance";

export const createMonobankPayment = async (orderPayload) => {
  const response = await axiosInstance.post("/payments/create", orderPayload);
  return response.data;
};

export const payWithGooglePay = async (paymentPayload) => {
  const response = await axiosInstance.post(
    "/payments/google-pay",
    paymentPayload,
    { timeout: 30000 }
  );
  return response.data;
};

export const getPaymentStatus = async (orderId, options = {}) => {
  const response = await axiosInstance.get(`/payments/status/${orderId}`, {
    params: {
      ...(options.type ? { type: options.type } : {}),
      _: Date.now(),
    },
    timeout: options.timeout || 15000,
  });
  return response.data;
};

export const getAdditionalPaymentLink = async (orderId, secureToken) => {
  const response = await axiosInstance.get(
    `/payments/additional/${orderId}/${secureToken}`
  );
  return response.data;
};
